import { z } from 'zod'

import type { CreatorFanStats } from '@/modules/overview/types'

export interface SubscribedPieChart {
  clicks: number
  subscribers: number
}

export interface SpendingPieChart {
  spenders: number
  nonSpenders: number
}

export interface Engagement {
  onlySubscribed: number
  subscribedAndOneMessage: number
  subscribedAndOnePurchase: number
  subscribedAndMoreThanOnePurchase: number
}

export interface SpecificTrackingLink {
  link: {
    id: number
    creatorId: number
    linkId: number
    url: string
    name: string
    type: LinkType
    createdAt: string
    expiredAt: string
    promotionCost: number
    trackingAttributes: {
      transitions: number
      campaignCode: number
    }
    trialAttributes: {
      subscribeDays: number
      subscribeCounts: number
    }
    claimers: {
      id: number
      name: string
      subscribedAt: string
      renewal: boolean
    }[]
  }
  engagement: Engagement
  bestFans: {
    fans: CreatorFanStats[]
  }
  investment: {
    profit: number
    promotionCost: number
  }
  subscribedPieChart: SubscribedPieChart
  spendingPieChart: SpendingPieChart
  claimedFans: number
  claimedFansInLast30Days: number
  linkClicks: number
  renewActive: number
  revenueInLast30Days: number
  totalRevenue: number
}

export const TrackingLinkSchema = z.object({
  averageFanSpending: z.number(),
  claimedFans: z.number(),
  claimedFansConversion: z.number(),
  createdAt: z.string(),
  linkClicks: z.number(),
  linkId: z.number(),
  name: z.string(),
  percentageSpendingFans: z.number(),
  revenue: z.number(),
  spendingFans: z.number(),
  url: z.string(),
  visible: z.boolean(),
  id: z.number(),
})

export type TrackingLink = z.infer<typeof TrackingLinkSchema>

export interface UpdateLinkTrackingPromotionCostForm {
  linkId: number
  type: LinkType
  promotionCost: number | undefined
}

export interface UpdateLinkTrackingVisibilityForm {
  linkId: number
  type: LinkType
  visible: boolean | undefined
}

export type LinkType = 'Trial' | 'Tracking'

export const EMPTY_SUBSCRIBED_PIE_CHART: SubscribedPieChart = {
  clicks: 0,
  subscribers: 0,
}

export const EMPTY_SPENDING_PIE_CHART: SpendingPieChart = {
  spenders: 0,
  nonSpenders: 0,
}

export const EMPTY_ENGAGEMENT: Engagement = {
  onlySubscribed: 0,
  subscribedAndOneMessage: 0,
  subscribedAndOnePurchase: 0,
  subscribedAndMoreThanOnePurchase: 0,
}

export interface ListCreationProgressResponse {
  failure: number
  remaining: number
  total: number
  success: number
  completed: boolean
}
